import { Config } from '@adornis/config/config.js';

export const whitelistConfig = new Config('nsc-whitelist', {
  TICKET_WHITELIST: {
    env: true,
    name: 'TICKET_WHITELIST',
    client: true,
    defaultVal: false,
    required: false,
    parse: val => {
      return typeof val === 'boolean' ? val : val === 'true';
    },
  },
  AGENT_WHITELIST: {
    env: true,
    name: 'AGENT_WHITELIST',
    client: true,
    defaultVal: false,
    required: false,
    parse: val => {
      return typeof val === 'boolean' ? val : val === 'true';
    },
  },
});
